import React from 'react';
import PropTypes from 'prop-types';

import {
  END_DATE,
} from '@zr/utilities/profileFields';

import { STRING_FIELD_EXPERIENCE_END_MONTH } from '../labels';

import FormikLabeledField from './FormikLabeledField';
import MonthOptions from '../MonthOptions';

import formikPropTypes from './formikPropTypes';

export function EndMonthField({
  name, formikProps,
}) {
  const { errors } = formikProps;

  return (
    <FormikLabeledField
      as="select"
      // since the profile field is the date combined, also display errors with that field
      error={errors[name] || errors[END_DATE]}
      formikProps={formikProps}
      name={name}
      label={STRING_FIELD_EXPERIENCE_END_MONTH}
      placeholder={STRING_FIELD_EXPERIENCE_END_MONTH}
    >
      <MonthOptions />
    </FormikLabeledField>
  );
}

EndMonthField.propTypes = {
  name: PropTypes.string.isRequired,
  formikProps: formikPropTypes.isRequired,
};

export default EndMonthField;
